import {
  fetchNavState,
  NavState,
  RedirectError,
} from '@amzn/aac-chrome-internal-api';
import ChromeInternalApiRequestConfig from './chrome-internal-api-request-config';

// Optional extra headers merged onto the base ChromeInternalApiRequestConfig
// for this single call (e.g. slice 20.2's `X-Aac-Shadow-Id` correlation
// header, sent only under T2). The base config is never mutated.
export interface GetNavStateOptions {
  headers?: Record<string, string>;
}

export default async (options?: GetNavStateOptions): Promise<NavState> => {
  try {
    // `await` is load-bearing: returning the promise un-awaited lets a
    // rejection bypass this catch, so the redirect never runs.
    if (window.AACChrome?.InternalAPI) {
      return await window.AACChrome.InternalAPI.NavStateHandler.getInstance().getNavState(
        {
          ...ChromeInternalApiRequestConfig,
          ...(options?.headers ? { headers: options.headers } : {}),
        },
      );
    }
    return await fetchNavState({
      ...ChromeInternalApiRequestConfig,
      ...(options?.headers ? { headers: options.headers } : {}),
    });
  } catch (error: any) {
    // redirect to redirectUrl if the API returns 302
    if (
      window &&
      error &&
      error.type === RedirectError.TYPE &&
      error.redirectUrl
    ) {
      window.location.replace(error.redirectUrl);
    }
    throw error;
  }
};
